import { render, staticRenderFns } from "./Results-modify.vue?vue&type=template&id=2eef4121&scoped=true&"
import script from "./Results-modify.vue?vue&type=script&lang=js&"
export * from "./Results-modify.vue?vue&type=script&lang=js&"
import style0 from "./Results-modify.vue?vue&type=style&index=0&id=2eef4121&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eef4121",
  null
  
)

export default component.exports